import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemMiniEntity } from '../../domain/entities/ItemMiniEntity'

export class ItemMiniModel extends ItemMiniEntity {
  constructor(dataDto: ItemMiniEntity) {
    super()
    mapEntityProperties<ItemMiniEntity>(this, dataDto, {})
  }
}
